import type {CSSProperties} from 'react';

import {forwardRef, type Ref} from 'react';

import styles from './FlexContainer.module.css';

export type FlexContainerProps = {
  column?: string;
  flexBasis?: string;
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?: CSSProperties['justifyContent'];
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch';
  flex?: string;
  gap?: CSSProperties['gap'];
  rowGap?: CSSProperties['rowGap'];
  columnGap?: CSSProperties['columnGap'];
  flexShrink?: boolean;
  flexGrow?: boolean;
  alignSelf?: CSSProperties['alignSelf'];
  debug?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const FlexContainer = forwardRef<HTMLDivElement, FlexContainerProps>(
  (
    {
      column,
      flexBasis,
      flexDirection,
      flexWrap,
      justifyContent,
      alignItems,
      flex,
      gap,
      rowGap,
      columnGap,
      flexShrink,
      flexGrow,
      alignSelf,
      style,
      className,
      children,
      ...rest
    },
    ref: Ref<HTMLDivElement>,
  ) => {
    const dynamicStyles: CSSProperties = Object.entries({
      flex,
      flexBasis,
      flexDirection,
      flexWrap,
      justifyContent,
      alignItems,
      gap,
      rowGap,
      columnGap,
      flexShrink: flexShrink === undefined ? undefined : flexShrink ? 1 : 0,
      flexGrow: flexGrow === undefined ? undefined : flexGrow ? 1 : 0,
      alignSelf,
      ...style,
    }).reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key as keyof CSSProperties] = value;
      }
      return acc;
    }, {} as any) as CSSProperties;

    return (
      <div
        ref={ref}
        className={`${styles.container} ${className || ''}`}
        style={dynamicStyles}
        id="flex-container"
        {...rest}
      >
        {children}
      </div>
    );
  },
);

export default FlexContainer;
